module.exports = __webpack_public_path__ + "media/images/soar/site/temp/logo_1-dbad68488415d9e630d44c68e7f11318.png";